/**
 * Operator identity for Team & Roles and collaboration forms.
 * Until full login exists, email (+ optional display name) lives in localStorage
 * and is sent as X-Actor-Email on API calls.
 */
import { useState } from 'react';

const NAME_KEY = 'enso.identity.name';
const EMAIL_KEY = 'enso.identity.email';

export function getMyIdentity(): string {
  try {
    return localStorage.getItem(NAME_KEY) || '';
  } catch {
    return '';
  }
}

export function setMyIdentity(name: string): void {
  try {
    localStorage.setItem(NAME_KEY, name.trim());
  } catch {
    /* ignore */
  }
}

export function getMyEmail(): string {
  try {
    return (localStorage.getItem(EMAIL_KEY) || '').trim().toLowerCase();
  } catch {
    return '';
  }
}

export function setMyEmail(email: string): void {
  try {
    localStorage.setItem(EMAIL_KEY, email.trim().toLowerCase());
  } catch {
    /* ignore */
  }
}

export function useMyIdentity(): [string, (name: string) => void] {
  const [name, setNameState] = useState(getMyIdentity);
  const update = (next: string) => {
    setMyIdentity(next);
    setNameState(next);
  };
  return [name, update];
}

export function useMyEmail(): [string, (email: string) => void] {
  const [email, setEmailState] = useState(getMyEmail);
  const update = (next: string) => {
    setMyEmail(next);
    setEmailState(next.trim().toLowerCase());
  };
  return [email, update];
}
